// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IDpg","newExpiryDate":"styles_newExpiryDate__1RUbk","footer":"styles_footer__1bJmq"};